module.exports = __webpack_public_path__ + "img/airplane-6.47191e18.jpg";